// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { SystemListState } from "@west/App/Store/Reducers";

export interface SystemListApiParameter extends ApiParameter {
    /**
     * listNames is a string that takes multiple value separate by comma
     * example: abc,cde,fgh ...etc
     */
    listNames?: string;
}

export interface SystemListModel {
    id: string;
    name: string;
    description?: string;
    additionalInfo?: string;
}

export interface SystemListCollectionModel extends BaseModel {
    systemList: SystemListState;
}

const systemListUrl = "api/xng/systemlist/name";

export async function getSystemList(parameter: SystemListApiParameter) {
    const systemListCollection = await get<SystemListCollectionModel>(systemListUrl, parameter);
    return systemListCollection;
}
